export function extractText(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    if (tempDiv.textContent != null && tempDiv.textContent !== '') {
        return tempDiv.textContent;
    }

    return tempDiv.innerText !== '' ? tempDiv.innerText : '';
}
